<mat-card *ngrxLet="authError$; let authError">
  <mat-card-title>
    {{ authError.title }}
  </mat-card-title>
  <mat-card-content>
    {{ authError.message }}
  </mat-card-content>
</mat-card>
